exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{z-index:10000;position:fixed;top:0;left:0;width:100vw;height:100vh;background-color:#fff}.overlay_header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.overlay_body,.overlay_header{width:calc(100% - 2rem);padding:1rem}.overlay_body{overflow-y:scroll;max-height:100vh}p.table-text{white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-625aba1e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/contactListDetailRow.vue
// module id = rJhI
// module chunks = 0